import React, { useState, useMemo } from 'react'
import withDefaultLayout from '@/hoc/WithDefaultLayout'
import { A4B_APPS } from '@/utils/constants'
import { useAppContext } from '@/components/AppContext'
import AdminBreadcrumb from '@/ui/organisms/AdminBreadcrumb'
import Error from '@/components/Error'
import ManageTrustees from '../components/ManageTrustees'



const TrusteesAdminUI = () => {
    const { app } = useAppContext()
    const isSrimandir = app === A4B_APPS.SRIMANDIR
    const [errorPage] = useState(false)

    const routes = useMemo(
        () => [
            { path: '/shrine/temple-profile', breadcrumbName: 'Temple Profile' },
            { path: '/shrine/trustee-profile', breadcrumbName: 'Manage Trustees' },
        ],
        [isSrimandir]
    )

    return (
        <div style={{ padding: '0 40px' }}>
            {errorPage ? (
                <Error text="Error while loading Trustees!" />
            ) : (
                <>
                    <AdminBreadcrumb routes={routes} />
                    <ManageTrustees />
                </>
            )}
        </div>
    )
}

export default withDefaultLayout(TrusteesAdminUI)
